import React from 'react'

var Company = React.createContext()
var CompanyDispatch = React.createContext()

function CompanyReducer(state, action) {
    switch (action.type) {
        case 'COMPANY':
			return { ...state, company: JSON.parse(localStorage.getItem('company')) }
		default:
            throw new Error(`Unhandled action type: ${action.type}`)
    }
}

function CompanyProvider({ children }) {
    var [state, dispatch] = React.useReducer(CompanyReducer, {
        company: JSON.parse(localStorage.getItem('company'))
    })
    return (
        <Company.Provider value={state}>
            <CompanyDispatch.Provider value={dispatch}>
                {children}
            </CompanyDispatch.Provider>
        </Company.Provider>
    )
}

function useCompanyState() {
    var context = React.useContext(Company)
    if (context === undefined) {
        throw new Error('useCompanyState must be used within a CompanyProvider')
    }
    return context
}

function useCompanyDispatch() {
    var context = React.useContext(CompanyDispatch)
    if (context === undefined) {
        throw new Error('useCompanyDispatch must be used within a CompanyDispatchProvider')
    }
    return context
}

function fetchCompanyData(dispatch) {
    dispatch({type: 'COMPANY'})
}

export { CompanyProvider, useCompanyState, useCompanyDispatch, fetchCompanyData }

